module.exports = __webpack_public_path__ + "static/media/target-audience.d6460b64.svg";